import React from "react";
import { createSvgIconComponent } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var IconCatchBrand = createSvgIconComponent({
  viewBox: "0 0 55 24",
  children: [___EmotionJSX("path", {
    key: "part-1",
    fill: "url(#outline-a)",
    d: "M48.832 2.304C47.768.818 46.058 0 44.017 0H8.228C5.502 0 3.653 1.983 3.235 3.94L.122 18.49c-.31 1.45-.023 2.815.81 3.844C1.8 23.408 3.156 24 4.749 24h39.438c1.92 0 3.559-.762 4.495-2.09l4.966-7.05c.49-.697 1.102-1.564 1.102-2.924 0-1.352-.73-2.426-1.076-2.86l-4.842-6.772Z"
  }), ___EmotionJSX("path", {
    key: "part-2",
    fill: "url(#outline-b)",
    d: "M47.697 3.115c-.562-.785-1.657-1.721-3.681-1.721H8.229c-1.985 0-3.329 1.427-3.63 2.837l-3.114 14.55c-.283 1.32.133 2.183.53 2.675.6.74 1.57 1.149 2.734 1.149h39.438c1.46 0 2.684-.547 3.354-1.5l4.967-7.05c.435-.619.848-1.203.848-2.12 0-.959-.58-1.756-.792-2.016l-4.867-6.804Z"
  }), ___EmotionJSX("path", {
    key: "part-3",
    fill: "#fff",
    d: "M5.961 4.524c.141-.66.868-1.735 2.268-1.735h35.788c.758 0 1.84.15 2.547 1.139l4.896 6.846s.502.575.502 1.164c0 .49-.233.803-.63 1.37l-4.93 6.997c-.423.601-1.246.908-2.214.908H4.75c-1.235 0-2.222-.634-1.9-2.138L5.96 4.525Z"
  }), ___EmotionJSX("path", {
    key: "part-4",
    fill: "#000096",
    d: "M50.37 12.049a1.236 1.236 0 1 1-2.472 0 1.236 1.236 0 0 1 2.472 0ZM18.966 16.826c-.003-.28.038-.606.145-1.105-.471.53-1.24 1.292-2.845 1.292-1.916 0-2.533-1.06-2.239-2.446.453-2.136 2.598-2.916 5.934-2.775.194-.842.251-1.62-.637-1.62-.546 0-1.123.295-1.296 1.184h-2.805c.092-.358.234-1.03.956-1.637.74-.624 2.031-.982 3.45-.982.7 0 2.176.093 2.83.903.396.483.428 1.216.25 2.058l-.776 3.647c-.119.561-.136.7-.16 1.48h-2.807v.001Zm-2-2.524c-.124.577.148 1.06.849 1.06.311 0 .884-.125 1.312-.748.34-.498.476-1.138.53-1.465-1.25.016-2.453.03-2.692 1.153ZM11.345 11.745c.155-.731.004-1.339-.76-1.339-1.075 0-1.556 1.09-1.848 2.463-.43 2.025.03 2.494.764 2.494.997 0 1.27-.997 1.397-1.59h2.962c-.406 1.979-2.263 3.24-4.632 3.24-2.494 0-4.114-1.325-3.515-4.145.655-3.086 3.043-4.131 5.242-4.131.842 0 2.23.14 2.925 1.121.518.717.429 1.434.364 1.886h-2.9v.002ZM34.588 11.745c.155-.731.003-1.339-.76-1.339-1.076 0-1.557 1.09-1.849 2.463-.43 2.025.03 2.494.764 2.494.997 0 1.271-.997 1.397-1.59h2.962c-.404 1.979-2.263 3.24-4.632 3.24-2.494 0-4.114-1.325-3.514-4.145.655-3.086 3.044-4.131 5.241-4.131.842 0 2.23.14 2.926 1.121.518.717.428 1.434.363 1.886h-2.898v.002ZM28.295 6.974l-2.943.576-.315 1.484H23.51l-.397 1.87h1.48l-.831 3.818c-.322 1.512-.02 2.29 2.318 2.29.998 0 1.529-.077 1.932-.14l.39-1.838c-.367.045-.508.045-.741.045-1.123 0-.997-.497-.807-1.463l.576-2.712h1.885l.398-1.87h-1.855l.437-2.06ZM46.245 9.532c-.514-.592-1.25-.794-2.014-.794-1.417 0-2.287.717-2.665 1.028l.894-4.19h-2.966l-2.387 11.25h2.93l.768-3.632c.139-.654.245-1.153.399-1.511.144-.312.528-1.092 1.463-1.092 1.216 0 .944 1.278.805 1.933l-.91 4.301h2.915l.984-4.644c.233-1.09.414-1.947-.216-2.649Z"
  }), ___EmotionJSX("defs", {
    key: "part-5"
  }, ___EmotionJSX("linearGradient", {
    id: "outline-a",
    x1: "0",
    x2: "54.749",
    y1: "11.999",
    y2: "11.999",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#6C0"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#CCE800"
  })), ___EmotionJSX("linearGradient", {
    id: "outline-b",
    x1: "-.003",
    x2: "54.747",
    y1: "11.998",
    y2: "11.998",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F6B123"
  }), ___EmotionJSX("stop", {
    offset: ".016",
    stopColor: "#F6B123"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#F46F21"
  })))]
});